import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseService } from '@easy-lib/modules/shared/services';
import {
	IPerformanceAssetValueHistoryResponse,
	IPerformanceResponse,
	IPortfolioAssetValueHistory,
	IPortfolioTransactionsHistory,
	IPortfolioTransactionsHistoryResponse
} from '@easy-lib/modules/portfolio';
import { IPortfolioItem } from '@easy-lib/modules/portfolio/models/portfolio-item.model';

@Injectable({
	providedIn: 'root'
})
export class PortfolioService extends BaseService {
	constructor() {
		super();
	}
	getPerformance(): Observable<IPerformanceResponse> {
		return this.httpService.get<IPerformanceResponse>(this.mtsPath + this.apiUrls.assets + 'performance');
	}

	getPerformanceAssetValueHistory(startFrom: string, isin?: string): Observable<IPortfolioAssetValueHistory[]> {
		return this.httpService
			.get<IPerformanceAssetValueHistoryResponse>(
				`${this.mtsPath}${this.apiUrls.assets}performance/AssetValue?${isin ? 'symbolIsin=' + isin + '&' : ''}${'startfrom=' + startFrom}`
			)
			.pipe(
				map(data => {
					return data.items;
					// .map(x=>({...x,dateNumbered : x.date}));
				})
			);
	}

	getPerformanceHistory(isin: string, skip: number, take: number): Observable<IPortfolioTransactionsHistory[]> {
		return this.httpService
			.get<IPortfolioTransactionsHistoryResponse>(
				`${this.mtsPath}${this.apiUrls.assets}performance/history?symbolIsin=${isin}${'&skip=' + skip}${'&take=' + take}`
			)
			.pipe(
				map(data => {
					return data.items.map(x => ({
						...x,
						periodicAveragePriceWithoutDps: x.periodicAveragePriceWithoutDPS,
						totalAveragePriceWithoutDps: x.totalAveragePriceWithoutDPS
					}));
				})
			);
	}

	getPortfolioSoldMinimalItems(): Observable<IPortfolioItem[]> {
		return this.httpService
			.get<IPortfolioItem[]>(`${this.mtsPath}${this.apiUrls.assets}performance/sold/concise`)
			.pipe(
				map(data => {
					data.forEach(item => {
						item.asset = 0;
						item.bonusShareVolume = 0;
					});
					return data as IPortfolioItem[];
				})
			);
	}

	getPortfolioSoldItemsDetail(symbolIsins: string[]): Observable<IPortfolioItem[]> {
		return this.httpService
			.post<any>(`${this.mtsPath}${this.apiUrls.assets}performance/sold`, { body: { symbolIsins } })
			.pipe(
				map(data => {
					return data.items as IPortfolioItem[];
				})
			);
	}
}
